const ResourcesRenderer = require("../common/ResourcesRenderer");
const Utils = require("../common/Utils");

/**
 * Base class for connectable resource renderers
 *
 * @class
 */
function ConnectableResourcesRenderer() {
    ResourcesRenderer.call(this);
    const self = this;

    const STATE_CONNECTED = "connected";
    const STATE_CONNECTING = "connecting";
    const STATE_DISCONNECTED = "disconnected";

    function getConnectedBadge(size, classes) {
        return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 32 32" class="' + classes + '">' +
            '<circle cx="16" cy="16" r="15" stroke="white" />' +
            '<polygon points="3.75,22.25 11.75,10.25 20,15.75 28,10.25 20,22.25 11.75,16.75" fill="white" stroke="white" stroke-width="0" />' +
            "</svg>";
    }

    function getClassForResourceState(resource) {
        if (resource.status === STATE_CONNECTED || resource.status === STATE_CONNECTING) {
            return resource.status;
        }
        return STATE_DISCONNECTED;
    }

    this.updateIcon = function(element, resource) {
        const state = self.getStateClass(resource);
        const overlay = element.find(".connectionOverlay");
        overlay.removeClass(STATE_CONNECTED)
            .removeClass(STATE_CONNECTING)
            .removeClass(STATE_DISCONNECTED)
            .addClass(state);

        const badge = element.find(".resourceBadgeContainer");
        badge.removeClass(STATE_CONNECTED)
            .removeClass(STATE_CONNECTING)
            .removeClass(STATE_DISCONNECTED)
            .addClass(state);

        // SVGs are special jQuery elements so we have to do it like this. There are no other
        // classes on the svg so we can just set it to the desired state
        element.find($(".listViewStatusIcon > svg")).attr("class", state);
    };

    /**
     * @override
     */
    this.render = function(resource, dontScale) {
        console.debug("Rendering Resource: name: '" + resource.name + "' id: '" + resource.id + "' type: '" + resource.type + "'");

        let $div;
        const state = self.getStateClass(resource);
        const classes = ["ui-li-thumb", "connectionOverlay", state];
        let badgeClasses = [state];

        if (self.hasCustomIcon(resource)) {
            $div = self.renderCustomIcon(resource);
            $div.append($("<div>", {class : classes.join(" ")}).append(self.renderStateBadge(resource, badgeClasses)));
        } else {
            $div = self.renderStandardIcon(resource, dontScale);
            badgeClasses = badgeClasses.concat(self.getExtraBadgeClasses());
            $div.append(self.renderStateBadge(resource, badgeClasses));
        }
        return $div;
    };

    /**
     * @override
     */
    this.renderResourceListViewBadge = function(resource) {
        return getConnectedBadge(this.getListViewBadgeSize(), getClassForResourceState(resource));
    };

    const super_getResourceIconText = this.getResourceIconText;

    /**
     * @override

     * @returns {string}
     */
    this.getResourceIconText = function(resource) {
        let iconText = "";
        if (!resource.hasOwnProperty("launchable") || resource.launchable === true) {
            iconText = super_getResourceIconText(resource);
        }
        return iconText;
    };

    const super_renderStateBadge = this.renderStateBadge;

    /**
     * @override
     *
     * @param resource
     * @param extraClasses
     *
     * @returns {*|jQuery.fn.init|Window.$.fn.init|jQuery|HTMLElement}
     */
    this.renderStateBadge = function(resource, extraClasses) {
        if (resource.dyn_state === "Disabled") {
            return super_renderStateBadge(resource, extraClasses);
        }
        extraClasses.push("resourceBadgeContainer");
        const $div = $("<div>", {class : extraClasses.join(" ")});
        $div.append(getConnectedBadge(this.getIconViewBadgeSize(), "resourceBadge"));
        return $div;
    };

    this.getStateClass = function(resource) {
        if (resource.dyn_state === "Disabled") {
            return undefined;
        }
        return getClassForResourceState(resource);
    };

    /**
     * Provides extra CSS classes to style the state badge of connectable resources
     * @returns {Array}
     */
    this.getExtraBadgeClasses = function() {
        return [];
    };
}

Utils.inherits(ConnectableResourcesRenderer, ResourcesRenderer);

module.exports = ConnectableResourcesRenderer;